export const getReactionActivityId = (activity) =>
  activity.startedConversationId || activity.id
